import React from "react";
import "./style.css";
import Loader from "../../components/Loader";
import Button from "../Button/Button";

const AccountInfos = ({
  firstName,
  lastName,
  cashBalance,
  inboundPendingBalance,
  isVerified,
  AccountOnboard,
  isLoading,
}) => {
  const formatBalance = (value) => {
    if (isLoading) return <Loader size={22} />;
    const amount = value ? Number(value) : 0;
    return (
      <span className="stat-value-amount">
        ${amount.toLocaleString("en-US", { minimumFractionDigits: 2 })}
      </span>
    );
  };

  return (
    <div className="account-infos">
      <div className="account-stats-grid">
        <div className="stat-card stat-card--highlight">
          <span className="stat-label">Cash balance</span>
          <div className="stat-value">{formatBalance(cashBalance)}</div>
        </div>

        <div className="stat-card">
          <span className="stat-label">Inbound pending</span>
          <div className="stat-value">{formatBalance(inboundPendingBalance)}</div>
        </div>

        <div className="stat-card">
          <span className="stat-label">First name</span>
          <div className="stat-value stat-value--text">
            {isLoading ? <Loader size={22} /> : firstName || "—"}
          </div>
        </div>

        <div className="stat-card">
          <span className="stat-label">Last name</span>
          <div className="stat-value stat-value--text">
            {isLoading ? <Loader size={22} /> : lastName || "—"}
          </div>
        </div>
      </div>

      <div className="verification-banner">
        <span className="stat-label">Verification status</span>
        <div className="verification-banner__body">
          {isLoading ? (
            <Loader size={24} />
          ) : isVerified ? (
            <>
              <span className="status-badge status-badge--verified">Verified</span>
              <p className="verification-message">
                Your identity is verified. You can add funds, withdraw, and send money.
              </p>
            </>
          ) : (
            <>
              <span className="status-badge status-badge--pending">Action required</span>
              <p className="verification-message verification-message--warning">
                Complete verification to unlock transfers and withdrawals.
              </p>
              <Button
                btnName="Verify account"
                onClick={AccountOnboard}
                disabled={isVerified}
                classe="btn--accent"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountInfos;
